export enum OpdrachtgeverEnum {
  ANDERS = 'Anders',
  GEMEENTE = 'Gemeente',
  MEERDERE_NAMELIJK = 'Meerdere namelijk',
  NOG_ONBEKEND = 'Nog onbekend',
  PARTICULIEREN = 'Particulieren',
  PROJECTONTWIKKELAAR = 'Projectontwikkelaar',
  WONINGBOUWCORPORATIE = 'Woningbouwcorporatie',
}
